import { render } from "./xIcon.vue?vue&type=template&id=d3da984c&scoped=true"
import script from "./xIcon.vue?vue&type=script&lang=js"
export * from "./xIcon.vue?vue&type=script&lang=js"

import "./xIcon.vue?vue&type=style&index=0&id=d3da984c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3da984c"]])

export default __exports__